<template>
  <div class="fd_body" v-if="body_show">
    <!-- 公用头部 -->
    <public-header :colors="'#fff'" :headimg="headImg"></public-header>
    <!-- 图片 -->
    <div class="men_detail">
      <img :key="item" v-for="item in imgData" :src="item" alt="" />
    </div>
    <!-- 结尾 -->
    <div class="men_detaips">
      <h2>少走弯路，就是捷径</h2>
      <h1>{{ price }}元</h1>
      <div class="">
        <div class="ps_dl">
          省下自己摸索花费的时间成本
          <br/>和盲目行动带来的试错成本
        </div>
      </div>
      <h3>本周剩余咨询名额  <span>{{ count }}  个</span><br/>马上预约，定制你的发展方案 </h3>
    </div>
    <!-- 选择导师 -->
    <div class="md_hs" v-if="count>0">
      <div v-if="button">
        <a @click="statistical_fn('tutorselect', 'totoring_choose')" class="md_href">选择导师咨询</a>
      </div>
      <div v-else>
        <div class="md_hsl" @click="pop_show = true">
          <img src="../../../assets/cepb1.png" />
          <p>分享好友</p>
        </div>
        <router-link to="/totoring_buy_success?pay=my" class="md_href">进入【辅导】</router-link>
      </div>
    </div>
    <div class="md_hs" v-else>
      <a class="md_href" style="background: #ccc;">选择导师咨询</a>
    </div>
    <div class="pop_img" v-show="pop_show" @click="pop_show = false"></div>
    <div v-show="share_href_state" class="perview_show new_year">
      <div class="perview_s">
        <img id="x_share_img" src="../../../assets/fd_cj.png" class="perview" />
      </div>
    </div>
  </div>
</template>
<script>
import {
  coachdetail
} from "@/api/totoring"
import {
  statistics
} from "@/api/public"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        headImg: "",
        imgData: [],
        price: 0,
        count: 0,
        button: false,
        pop_show: false,
        share_href_state: false,
        body_show: false
      }
    },
    methods: {
      statistical_fn(type, path) {
        statistics({
            type
          })
          .then((data) => {
            this.$router.push(path);
          })
      },
      pullData() {
        coachdetail()
          .then((data) => {
            shareCon("totoring", this);
            this.body_show = true;
            this.headImg = data.headimg;
            this.imgData = data.picture;
            this.button = data.button;
            this.price = data.price;
            this.count = data.count;
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.fd_body {
  background: url(../../../assets/fd_body.png) repeat-y top center;
  background-size: contain;
  width: 100%;
  height: 100%;
  padding-bottom: changeRem(3)+px;
}

.men_detail {
  img {
    max-width: 100%;
    display: block;
  }
}

.men_detaips {
  width: 100%;
  height: changeRem(11.3)+px;
  background: url(../../../assets/md_bg.png) no-repeat top center;
  background-size: cover;
  margin: 0 auto;
  text-align: center;
  padding-top: changeRem(1.4)+px;
  h2 {
    font-size: changeRem(0.68)+px;
    color: #333;
    font-weight: bold;
  }
  h1 {
    font-size: changeRem(1)+px;
    color: #EB5032;
    margin-top: changeRem(1)+px;
  }
  h3 {
    font-size: changeRem(0.6)+px;
    color: #333;
    line-height: changeRem(0.92)+px;
    margin-top: changeRem(0.6)+px;
    font-weight: normal;
    span {
      color: #EB5032;
    }
  }
  .ps_dl {
    font-size: changeRem(0.6)+px;
    margin: 0 auto;
    margin-top: changeRem(1.08)+px;
    width: changeRem(8.8)+px;
    // height: changeRem(2.52)+px;
    background: rgba(245, 127, 23, 1);
    padding: changeRem(0.4)+px 0;
    line-height: changeRem(0.8)+px;
    color: #fff;
    text-align: center;
  }
}

.md_hs {
  height: changeRem(1.96)+px;
  padding: 0;
  background: #fff;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  text-align: center;
  .md_hsl {
    float: left;
    width: changeRem(4.2)+px;
    padding-top: changeRem(0.15)+px;
    height: changeRem(1.96)+px;
    background: #fff;
    img {
      width: changeRem(0.8)+px;
      vertical-align: middle;
    }
    p {
      color: #EB5032;
      font-size: changeRem(0.36)+px;
      line-height: changeRem(0.7)+px;
      margin-top: changeRem(0.1)+px;
    }
  }
  .md_href {
    width: 100%;
    height: changeRem(1.96)+px;
    line-height: changeRem(1.96)+px;
    background: rgba(235, 80, 50, 1);
    display: block;
    color: #fff;
    font-size: 35px;
    border-radius: 0;
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}
</style>
